import { Textarea } from "ui";

export interface Props {
  id: string;
  onChange(value: string): void;
  value: string;
  disabled?: boolean;
}

export function LongText(props: Props) {
  return (
    <Textarea
      id={props.id}
      rows={4}
      disabled={props.disabled}
      value={props.value}
      onChange={(e) => {
        props.onChange(e.target.value);
      }}
    />
  );
}
